import type { ReactNode } from "react";

export interface ProgressDialogProps {
  open: boolean;
  title: string;
  body: ReactNode;
}

export function ProgressDialog({ open, title, body }: ProgressDialogProps) {
  if (!open) return null;

  return (
    <div
      className="tp-sheet-overlay tp-progress-overlay"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="tp-progress-title"
      aria-describedby="tp-progress-body"
      aria-busy="true"
    >
      <div className="tp-sheet tp-progress-dialog">
        <div className="tp-progress-spinner" aria-hidden="true" />
        <div id="tp-progress-title" className="tp-h1" style={{ marginBottom: 8 }}>
          {title}
        </div>
        <div
          id="tp-progress-body"
          className="tp-body"
          style={{ color: "var(--tp-ink-soft)", fontSize: 15 }}
        >
          {body}
        </div>
      </div>
    </div>
  );
}
